<template lang="pug">
.stureport(style="height:100vh;width:100%;background:#8EA3C0")
  .back(style="position:absolute;" @click="goback") X
  .mainBox
    Spin(v-if="totaldata.length===0",fix)
    .leftbox(ref="leftboxs" @scroll="onScroll")
      .menu(style="margin-bottom:20px")
        .MenuItem(v-for="(item,index) in navigationList" @click="changeMenu(index)" :class="index===activeMenu ?'active':''" v-if="totaldata[index]") {{item.stepName}}
      div
        div(v-for="(item,idx) in totaldata",:ref="`leftboxs${idx}`")
          .titleName {{item.caseHall.caseStepName}}
          .tasks
            .task(v-for="(item3,index3) in item.tasks",:key="index3")
              .taskinfo 任务{{index3+1}}：{{item3.taskName}}：{{item3.taskContent}}
              .taskcontents(v-for="(item4,index4) in item3.taskScenarios",:key="index4")
                .taskcontent(v-for="(item5,index5) in JSON.parse(item4.taskData)",:key="index5")
                  .xcontent(v-if="item4.departmentName ==='民意调查中心'") 民意调查中心
                  .xcontent(v-if="item4.departmentName !=='民意调查中心'") {{JSON.parse(item5[0].teaControl).stem}}
                  .xcontent(v-if="item4.departmentName !=='民意调查中心'" v-html="question(JSON.parse(item5[0].teaControl))")
                  .xstuanswer(v-html="ee(JSON.parse(item5[0].stuControl), JSON.parse(item5[0].teaControl))")
                  .xbox(v-if="item4.departmentName !=='民意调查中心'")
                    .xanswer(v-show="isviewAnswer? true : $role.role!=='student'")
                      .answertitle 参考答案
                      .xanswercontent(v-if="JSON.parse(item5[0].teaControl).type === 'MATERIALANALYSISPROBLEM'")
                        //- .xanswercontent1(v-html="question(JSON.parse(item5[0].teaControl))")
                        .xanswercontent1(v-html="answer(JSON.parse(item5[0].teaControl))")
                      .xanswercontent(v-else-if="JSON.parse(item5[0].teaControl).type==='TABLEQUESTION'" v-for="tabItem in ReferenceAnswers(item5[0])" style='display:flex;flex-wrap: wrap')
                        div(v-if="!tabItem.isShowAnswer") {{ tabItem.title}}、
                        div(v-for="tabItem2,tabIndex2 in tabItem.children.flatMap((e) => e)" class='tabItem2')
                          div(v-if="!tabItem2.isShowAnswer") {{ tabItem2.title }}
                            span 、
                          div(v-for="tabItem3 in tabItem2.children.flatMap((e) => e)")
                            div(v-if="!tabItem3.title.isShowAnswer") {{  tabItem3.title.name}}
                              span 、
                            div(v-if="!tabItem3.estimate.isShowAnswer") {{tabItem3.estimate.name}}: {{tabItem3.estimate.fraction}}
                            div(v-if="!tabItem3.weight.isShowAnswer") 权重: {{tabItem3.weight.fraction}}
                            //-div(v-if="!tabItem3.answer.isShowAnswer") {{tabItem3.answer.name}}: {{tabItem3.estimate.fraction}}
                      .xanswercontent(v-else-if="JSON.parse(item5[0].teaControl).type==='ligatureQuestion'" v-for="ligature,ligatureIndex in ReferenceAnswers(item5[0]).taList")
                        div( style='display:flex;flex-wrap: wrap;')
                          div  {{ligature.replace(/,/g, '+')}}
                            span(v-if="ReferenceAnswers(item5[0]).taList.length-1!==ligatureIndex") ;
                      .xanswercontent(v-else-if="JSON.parse(item5[0].teaControl).type==='determineQuestion'" v-for="mistake,mistakeIndex in ReferenceAnswers(item5[0])")
                        div( style='display:flex')
                          div  {{mistake.position}} + {{ mistake.question }} + {{ mistake.desc }}
                      .xanswercontent(v-else v-html="ReferenceAnswers(item5[0])")
                    .xsysscore 评分
                    .xsysscore1
                      span 题目分数：{{JSON.parse(item5[0].teaControl).score}}
                      span 得分：{{JSON.parse(item5[0].stuControl).score}}
                    .xkeywords(v-if="JSON.parse(item5[0].teaControl).type === 'GAPFILLING'") 关键词
                    template(v-if="JSON.parse(item5[0].teaControl).scoringKeywords && JSON.parse(item5[0].teaControl).type === 'GAPFILLING'")
                      .xkeywordcontent(v-for='k in JSON.parse(JSON.parse(item5[0].teaControl).scoringKeywords)') {{k}}
                    .xkeywordcontent(v-if="!JSON.parse(item5[0].teaControl).scoringKeywords && JSON.parse(item5[0].teaControl).type === 'GAPFILLING'") 暂无
                    .xalanis(v-show="isviewAnswer? true : $role.role!=='student'") 解析
                    .xalaniscontent(v-show="isviewAnswer? true : $role.role!=='student'") {{JSON.parse(item5[0].teaControl).analysis}}
                  .xbox(v-if="item4.departmentName ==='民意调查中心'")
                    .xanswer(v-show="isviewAnswer ? true : $role.role!=='student'")
                      .answertitle 参考答案
                      .xanswercontent(v-html="JSON.parse(item4.functionName).stem")
                    .xsysscore 评分
                    .xsysscore1
                      span 题目分数：{{JSON.parse(item4.functionName).score}}
                      span 得分：{{JSON.parse(item5[0].stuControl).score}}
                    //- .xkeywords 关键词
                    //- template(v-if='JSON.parse(item4.functionName).scoringKeywords')
                    //-   .xkeywordcontent(v-for='k in JSON.parse(item4.functionName).scoringKeywords') {{k}}
                    //- .xkeywordcontent(v-else) 暂无
                    .xalanis(v-show="isviewAnswer? true : $role.role!=='student'") 解析
                    .xalaniscontent(v-show="isviewAnswer? true : $role.role!=='student'") {{JSON.parse(item4.functionName).answer}}
    .rightbox(v-if="changebox")
      .title 总分
      .userInfo
        .userImg
          img(:src="userinfo.headImagePath")
        .userName {{userinfo.name}}
        .totalscore() {{totalscore2()}}
        //- .totalscore(v-if="scoreinfo.hasOwnProperty('teaAssessScore')") {{scoreinfo.teaFinalityScore + scoreinfo.teaAssessScore + scoreinfo.teaExecuteScore + scoreinfo.teaFormulateScore}}
        .sysscore
          .sys(v-for="(item,index) in navigationList" :key="item.id")
            .content {{ item.stepName }}
            //- .littlescore(v-if="form.FormulateScore === 0") {{scoreinfo.teaFormulateScore ? scoreinfo.teaFormulateScore : scoreinfo.sysFormulateScore}}
            //- .littlescore(v-if="form.FormulateScore !== 0") {{form.FormulateScore}}
            //- .littlescore {{form.FormulateScore}}
      Button.change(v-show="$role.role!=='student'" :class="scoreagain==='待审批'?'':'gray'" @click="changeBox" :disabled="scoreagain!=='待审批'") 修改评分
      Button.commit(v-if="scoreagain==='待审批' && $role.role!=='student'",@click="confirmToGradeStu") 提交
      Button.gobackBtn(v-else,@click="goback",long,ghost,type="primary") 返回
    .rightbox2(v-else)
      .userInfo2 教师评分
      .userImg2
        img(:src="userinfo.headImagePath")
        span.userName2 {{userinfo.name}}
      .sysscore2
        .sys2(v-for="(item,index) in navigationList" :key="item.id")
          .content2 {{ item.stepName }}
            span(style="color:red") ({{totaldata[0]?totaldata[index].caseHall.score:100}})
          .score
            //- .littlescoresys {{scoreinfo ? scoreinfo.sysFormulateScore : "**"}}分

            InputNumber.little1scoreself(v-model="item.score" :max="totaldata[0]?totaldata[index].caseHall.score:100" :min="0")
            span.span 分
        // .sys2
        //   .content2 政策执行&nbsp{{scoreinfo.pyExecuteScore|| scoreinfo.pyExecuteScore == 0?`(${scoreinfo.pyExecuteScore})`:"--"}}
        //   .score
        //     .littlescoresys(v-if="totaldata.length>1") {{scoreinfo ? scoreinfo.sysExecuteScore : "**"}}分
        //     .littlescoresys(v-if="totaldata.length<2") --
        //     InputNumber.little1scoreself(v-if="totaldata.length>1" v-model="form.ExecuteScore" :max="totaldata[1]?totaldata[1].caseHall.score:100" :min="0" :disabled="jungleState('政策执行')")
        //     Input.little1scoreself(v-if="totaldata.length<2" v-model="content" :disabled="true")
        //     span.span 分
        // .sys2
        //   .content2 政策评估&nbsp{{scoreinfo.pyAssessScore || scoreinfo.pyAssessScore == 0?`(${scoreinfo.pyAssessScore})`:"--"}}
        //   .score
        //     .littlescoresys(v-if="totaldata.length>2") {{scoreinfo ? scoreinfo.sysAssessScore : "**"}}分
        //     .littlescoresys(v-if="totaldata.length<3") --
        //     InputNumber.little1scoreself(v-if="totaldata.length>2" v-model="form.AssessScore" :max="totaldata[2]?totaldata[2].caseHall.score:100" :min="0" :disabled="jungleState('政策评估')")
        //     Input.little1scoreself(v-if="totaldata.length<3" v-model="content" :disabled="true")
        //     span.span 分
        // .sys2
        //   .content2 政策终结&nbsp{{scoreinfo.pyFinalityScore || scoreinfo.pyFinalityScore == 0?`(${scoreinfo.pyFinalityScore})`:"--"}}
        //   .score
        //     .littlescoresys(v-if="totaldata.length>3") {{scoreinfo ? scoreinfo.sysFinalityScore : "**"}}分
        //     .littlescoresys(v-if="totaldata.length<4") --
        //     InputNumber.little1scoreself(v-if="totaldata.length>3" v-model="form.FinalityScore" :max="totaldata[3]?totaldata[3].caseHall.score:100",:min="0" :disabled="jungleState('政策终结')")
        //     Input.little1scoreself(v-if="totaldata.length<4" v-model="content" :disabled="true")
        //     span.span 分
        .btn
          Button(v-if="$role.role!=='student'" @click="cancel").cancel 取消
          Button(@click="ok").sure 确定
</template>
<script>
export default {
  data() {
    return {
      // offsetTop: this.$refs.leftboxs.scrollTop,
      content: "--",
      MenuItem: ["政策制定", "政策执行", "政策评估", "政策终结"],
      activeMenu: 0,
      offsetTop0: 0,
      offsetTop1: 0,
      offsetTop2: 0,
      offsetTop3: 0,
      singledata: {},
      changebox: true,
      scoreagain: this.$route.query.state,
      isviewAnswer: this.$route.query.isviewAnswer,
      role: this.$role.role,
      showPlan: "收起",
      form: {
        FormulateScore: 0,
        ExecuteScore: 0,
        AssessScore: 0,
        FinalityScore: 0
      },
      tsId: "",
      modal1: false,
      totaldata: [], // 总数据
      // questiondata: [], // 题目数据
      // taskdata: [], // 任务下的总信息
      // stuquestion: [],
      userinfo: [], // 学生信息
      scoreinfo: {}, // 系统得分信息
      navigationList: [] // 阶段
    };
  },
  // watch: {
  //   offsetTop() {
  //     console.log(this.$refs.leftboxs.scrollTop);
  //   }
  // },

  methods: {
    totalscore2() {
      let tolal = 0;
      tolal = this.navigationList.reduce((total, item) => total + item.score, 0);
      console.log("🚀 ~ totalscore2 ~ tolal:", tolal);
      return Number(tolal).toFixed(1);
    },
    jungleState(val) {
      const find = (item) => {
        return item.caseHall.caseStepName === val;
      };
      if (!this.totaldata.find(find)) {
        return true;
      }
      return false;
    },
    answer(val) {
      if (val.answer) {
        if (JSON.parse(val.answer).parseAnswer) {
          return JSON.parse(val.answer).parseAnswer;
        }
        return "未设置";
      }
      return "未设置";
    },
    question(val) {
      if (val.answer) {
        return JSON.parse(val.answer).parseQuestion;
      }
      return "";
    },
    goback() {
      // if (sessionStorage.getItem("lastUrl")) {
      //   this.$router.push(sessionStorage.lastUrl);
      // } else {
      //   this.$router.go(-1);
      // }
      this.$router.go(-1);
    },
    gobacktoCase() {
      this.$router.go(-1);
    },
    changeMenu(name) {
      this.activeMenu = name;
      console.log(this.activeMenu, "this.activeMenu");

      if (!this.totaldata[name]) {
        return false;
      }
      const index = name.toString();
      this.singledata = this.totaldata[index];
      const top = this.$refs[`leftboxs${index}`][0].offsetTop - 100;
      this.$refs.leftboxs.scrollTop = top;
    },
    cancel() {
      this.changebox = true;
      // this.InitializeScore();
      this.dealData(this.scoreinfo);
    },
    ok() {
      this.changebox = true;
    },
    changeBox() {
      // 修改评分
      this.changebox = false;
    },
    ReferenceAnswers(value) {
      const x = JSON.parse(value.teaControl);
      const I = ["A", "B", "C", "D", "E", "F", "G", "I", "H"];
      switch (x.type) {
        case "SINGLECHOICE":
          if (x.answerContent) {
            return `${I[+x.answer]}、
          ${x.answerContent}`;
          }
          return "未设置";
        case "FILLBLANKS":
          if (x.answerContent) {
            let i = "";
            JSON.parse(x.answerContent).forEach((res) => {
              i += `<div>${res}</div>`;
            });
            return i;
          }
          return "未设置";
        case "GAPFILLING":
          if (x.metas) {
            let i = "";
            JSON.parse(x.metas).forEach((res) => {
              i += `<span style='margin-right:15px'>${res}</span>`;
            });
            return i;
          }
          return "未设置";
        case "MULTIPLECHOICEA":
          console.log(x);
          if (x.metas) {
            let i = "";
            JSON.parse(x.answer).forEach((res) => {
              const index = res.substring(2, 3);
              i += `<div>${res}:${JSON.parse(x.metas)[index - 1]}</div>`;
            });
            return i;
          }
          return "未设置";
        case "MULTIPLECHOICEB":
          if (x.metas) {
            let i = "";
            JSON.parse(x.answer).forEach((res) => {
              const index = res.substring(2, 3);
              i += `<div>${res}:${JSON.parse(x.metas)[index - 1]}</div>`;
            });
            return i;
          }
          return "未设置";
        default:
          break;
      }
      // if (x.type === "SINGLECHOICE") {
      //   return `${I[+x.answer]}、
      //     ${JSON.parse(x.metas)[+x.answer]}`;
      // }
      // if (x.type === "FILLBLANKS") {
      //   // let i = "";
      //   // JSON.parse(JSON.parse(value.teaControl).answerContent).forEach(res => {
      //   //   i += `<div>${res}</div>`;
      //   // });
      //   // return i;
      //   if (x.answerContent) {
      //     let i = "";
      //     JSON.parse(x).forEach(res => {
      //       i += `<div>${res}</div>`;
      //     });
      //     return i;
      //   }
      //   return "未设置";
      // }
      // if (x.type === "GAPFILLING") {
      //   if (x.metas) {
      //     let i = "";
      //     JSON.parse(x.metas).forEach(res => {
      //       i += `<span style='margin-right:15px'>${res}</span>`;
      //     });
      //     return i;
      //   }
      //   return "未设置";
      // }
      // if (x.type === "MULTIPLECHOICEA") {
      //   let i = "";
      //   JSON.parse(x.answer).forEach(res => {
      //     const index = res.substring(2, 3);
      //     i += `<div>${res}:${JSON.parse(x.metas)[index - 1]}</div>`;
      //   });
      //   return i;
      // }
      if (x.answer || x.answer === 0) {
        // eslint-disable-next-line no-restricted-globals
        if (isNaN(x.answer)) {
          // eslint-disable-next-line no-restricted-globals
          return x.answer;
        }
        return I[x.answer];
      }
      if (x.metas) {
        return JSON.parse(x.metas);
      }
      return "未设置";
    },
    qq(x) {
      console.log(x);
      if (x.answerContent) {
        let i = "";
        JSON.parse(x).forEach((res) => {
          i += `<div>${res}</div>`;
        });
        return i;
      }
      return "未设置";
    },
    ee(x, y) {
      console.log(x, "xxxxxxx");

      if (!x) {
        return;
      }
      if (x.controlTypes === "ligatureQuestion") {
        let i = "";
        JSON.parse(x.questionAnswer).forEach((e, index) => {
          i += `
          <div>${e.replace(/,/g, "+")}
            <span>${JSON.parse(x.questionAnswer).length - 1 !== index ? ";" : ""}</span>
            </div>`;
        });
        return i;
      }
      if (x.controlTypes === "TABLEQUESTION") {
        console.log(JSON.parse(x.questionAnswer), "2222222");

        const generateHTML = (data) => {
          let html = "";

          const processNode = (node) => {
            console.log("🚀 ~ processNode ~ node:", node);
            if (node.title !== undefined && !node.isShowAnswer && typeof node.title === "string") {
              html += `<div>${node.title}</div>`;
            } else if (typeof node.title.name === "string" && !node.title.children && !node.title.isShowAnswer) {
              html += `<div>${node.title.name}</div>`;
            }
            if (node.estimate !== undefined && !node.estimate.isShowAnswer) {
              html += `<div>${node.estimate.name}:${node.estimate.fraction}</div>`;
            }
            if (node.weight !== undefined && !node.weight.isShowAnswer) {
              html += `<div>权重:${node.weight.fraction}</div>`;
            }
            if (node.children && node.children.length > 0) {
              node.children.forEach(processNode);
            }
          };

          data.forEach(processNode);

          return html;
        };

        // 假设 x.questionAnswer 是一个 JSON 字符串
        const questionAnswer = JSON.parse(x.questionAnswer);

        return generateHTML(questionAnswer);
      }
      if (x.controlTypes === "determineQuestion") {
        let i = "";
        JSON.parse(x.questionAnswer).forEach((e) => {
          i += `<div>${e.position}'+'${e.question}'+'${e.desc}</div>`;
        });
        return i;
      }
      if (x.controlTypes === "FILLBLANKS") {
        let i = "";
        JSON.parse(x.stuAnswerContent).forEach((res) => {
          i += `<div>${res}</div>`;
        });
        return i;
      }
      if (x.controlTypes === "SINGLECHOICE") {
        let i = "";
        const I = ["A", "B", "C", "D", "E", "F", "G", "I", "H"];
        i = `${I[+x.questionAnswer]}、${x.stuAnswerContent}`;
        return i;
      }
      if (x.controlTypes === "GAPFILLING") {
        let i = "";
        JSON.parse(x.questionAnswer).forEach((res) => {
          i += `<span style='margin-right:15px;background:#2D8CF0;color:#fff;padding:5px;display:inline-block;font-size:14px;margin-bottom:5px;border-radius:3px'>${res}</span>`;
        });
        return i;
      }
      if (x.controlTypes === "MULTIPLECHOICEA") {
        let i = "";
        JSON.parse(x.questionAnswer).forEach((res) => {
          i += `<div>选项${res + 1}:${JSON.parse(y.metas)[res]}</div>`;
        });
        return i;
      }
      if (x.controlTypes === "MULTIPLECHOICEB") {
        console.log(x);
        let i = "";
        JSON.parse(x.questionAnswer).forEach((res, index) => {
          if (res) {
            i += `<div>选项${index + 1}:${JSON.parse(y.metas)[index]}</div>`;
          }
        });
        return i;
      }
      try {
        // console.log(JSON.parse(x));
        const xt = JSON.parse(x.questionAnswer);
        let s = "";
        xt.forEach((res) => {
          s = `${s}${res}、`;
        });
        return s.substring(0, s.length - 1);
      } catch (error) {
        const I = ["A", "B", "C", "D", "E", "F", "G", "I", "H"];
        return I[+x.questionAnswer] || x.questionAnswer;
      }
    },
    stuReturn() {
      this.$router.push("/Student/case_list");
    },
    changePlan() {
      if (this.showPlan === "展开") {
        this.showPlan = "收起";
      } else {
        this.showPlan = "展开";
      }
    },
    showStuData() {
      const data = {
        experimentId: this.$route.query.experimentid,
        userId: this.$route.query.usercode
      };
      this.$http.showStuData(data).then((res) => {
        if (res.data.success) {
          this.totaldata = res.data.data;
          this.singledata = this.totaldata[0];
          this.queryStuScoreRequest();
        }
      });
    },
    confirmToGradeStu() {
      this.$Modal.confirm({
        title: "系统提示",
        content: "<p>是否确定提交，提交后评分不可修改</p>",
        onOk: () => {
          this.teacherToGradeStu();
        }
      });
    },
    teacherToGradeStu() {
      // 老师打分
      // const data = {
      //   experimentId: this.$route.query.experimentid,
      //   teaFormulateScore: this.form.FormulateScore,
      //   userCode: this.$route.query.usercode
      // };
      // if (this.totaldata.length === 4) {
      //   // 到终结阶段了
      //   data.teaAssessScore = this.form.AssessScore;
      //   data.teaExecuteScore = this.form.ExecuteScore;
      //   data.teaFinalityScore = this.form.FinalityScore;
      // } else if (this.totaldata.length === 3) {
      //   data.teaAssessScore = this.form.AssessScore;
      //   data.teaExecuteScore = this.form.ExecuteScore;
      // } else if (this.totaldata.length === 2) {
      //   data.teaExecuteScore = this.form.ExecuteScore;
      // }
      const teaChJson = JSON.stringify(
        this.navigationList.map((m) => {
          return {
            caseStep: m.caseStep,
            score: m.score,
            stepName: m.stepName
          };
        })
      );
      this.$http
        .teacherToGradeStu({
          experimentId: this.$route.query.experimentid,
          userCode: this.$route.query.usercode,
          teaChJson
        })
        .then((res) => {
          if (res.data.success) {
            this.$Message.success("教师评分成功");
            this.scoreagain = "已审批";
            this.queryStuScoreRequest();
            const query = JSON.parse(JSON.stringify(this.$route.query));
            query.state = "已审批";
            this.$router.push({
              path: "/stuReport",
              query
            });
          } else {
            this.$Message.error("教师还不能评分！");
          }
        });
    },
    queryStuScoreRequest() {
      // 查询系统评分
      const data = {
        experimentId: this.$route.query.experimentid,
        userId: this.$route.query.usercode
      };
      this.$http.queryStuScoreRequest(data).then((res) => {
        if (res.data.success) {
          if (res.data.data) {
            this.scoreinfo = res.data.data;
            if (res.data.data.sysChJson) {
              this.navigationList = JSON.parse(res.data.data.sysChJson);
            }
            if (res.data.data.teaChJson) {
              this.navigationList = JSON.parse(res.data.data.teaChJson);
            }
            this.dealData(res.data.data);
          }
        }
      });
    },
    dealData(data) {
      this.form.FormulateScore =
        data.teaFormulateScore || data.teaFormulateScore === 0
          ? data.teaFormulateScore
          : data.sysFormulateScore;
      this.form.ExecuteScore =
        data.teaExecuteScore || data.teaExecuteScore === 0
          ? data.teaExecuteScore
          : data.sysExecuteScore;
      this.form.AssessScore =
        data.teaAssessScore || data.teaAssessScore === 0
          ? data.teaAssessScore
          : data.sysAssessScore;
      this.form.FinalityScore =
        data.teaFinalityScore || data.teaFinalityScore === 0
          ? data.teaFinalityScore
          : data.sysFinalityScore;
    },
    getuserinfo() {
      const data = {
        code: this.$route.query.usercode
      };
      this.$http.userInfo(data).then((res) => {
        if (res.data.success) {
          this.userinfo = res.data.data;
          //
        }
      });
    },
    getIsviewAnswer() {
      console.log("isviewAnswer");
      this.isviewAnswer = this.isviewAnswer === "true";
    },
    onScroll() {
      if (this.$refs.leftboxs3) {
        this.scrollTop3 = this.$refs.leftboxs3[0].offsetTop - this.$refs.leftboxs.scrollTop;
      }
      if (this.$refs.leftboxs2) {
        this.scrollTop2 = this.$refs.leftboxs2[0].offsetTop - this.$refs.leftboxs.scrollTop;
      }
      if (this.$refs.leftboxs1) {
        this.scrollTop1 = this.$refs.leftboxs1[0].offsetTop - this.$refs.leftboxs.scrollTop;
      }
      // if (this.$refs.leftboxs3 && this.scrollTop3 - 110 < 0) {
      //   this.activeMenu = 3;
      // } else if (this.$refs.leftboxs2 && this.scrollTop2 - 110 < 0) {
      //   this.activeMenu = 2;
      // } else if (this.$refs.leftboxs1 && this.scrollTop1 - 110 < 0) {
      //   this.activeMenu = 1;
      // } else {
      //   this.activeMenu = 0;
      // }
      //   } else if (scrollTop2 - 100 === 0) {
      //     this.activeMenu = 2;
      //   } else if (scrollTop1 - 100 === 0) {
      //     this.activeMenu = 1;
      //   } else if (scrollTop0 - 100 === 0) {
      //     this.activeMenu = 0;
      //   }
    }
    // InitializeScore() {
    //   if (
    //     !this.scoreinfo.teaAssessScore &&
    //     this.scoreinfo.teaAssessScore !== 0
    //   ) {
    //     this.form.FormulateScore = this.scoreinfo.sysFormulateScore;
    //     this.form.ExecuteScore = this.scoreinfo.sysExecuteScore;
    //     this.form.AssessScore = this.scoreinfo.sysAssessScore;
    //     this.form.FinalityScore = this.scoreinfo.sysFinalityScore;
    //   } else {
    //     this.form.FormulateScore = this.scoreinfo.teaFormulateScore;
    //     this.form.ExecuteScore = this.scoreinfo.teaExecuteScore;
    //     this.form.AssessScore = this.scoreinfo.teaAssessScore;
    //     this.form.FinalityScore = this.scoreinfo.teaFinalityScore;
    //   }
    // }
  },
  // watch: {
  //   "$route.query": {
  //     handler: (newVal, oldVal) => {
  //       console.log(newVal, oldVal);
  //     },
  //     deep: true
  //   }
  // scoreinfo: {
  //   handler() {
  //     this.InitializeScore();
  //   },
  //   deep: true
  // }
  // },
  created() {
    this.modal1 = true;
    this.getuserinfo();
    this.getIsviewAnswer();
    // this.queryStuScoreRequest();
    this.showStuData();
    this.getnavigationList();
  }
};
</script>
<style lang="stylus" scopd>
.stureport
  text-align left
  position relative
  display -webkit-flex
  display flex
  -webkit-align-items center
  align-items center
  -webkit-justify-content center
  justify-content center
  .back
    position absolute
    top 4%
    right 12%
    font-size 26px
    color #FFFFFF
    cursor pointer
    z-index 10000
.mainBox
  width 65%
  // height 1000px
  position relative
  // background #878787
  .leftnoinfo
    font-size 30px
    line-height 300px
    text-align center
  .leftbox, .leftnoinfo
    width 74%
    border-right 1px solid #ccc
    height 604px
    border-radius 8px 0 0 8px
    overflow scroll
    padding 20px
    background white
    padding-top 100px
    // margin-bottom: 120px;
    float left
    .menu
      position absolute
      width 74%
      top 0
      left 0
      background #fff
      border-bottom 1px solid #ccc
      border-right 1px solid #ccc
      border-radius 8px 0px 0px 0px
      .active
        color #4A90E2
        border-bottom 2px solid #4A90E2
      .MenuItem
        float left
        text-align center
        line-height 50px
        height 50px
        cursor pointer
        font-size 14px
        padding-left: 10px;
        padding-right: 10px;
    .titleName
      width 100%
      height 48px
      background rgba(238, 242, 245, 1)
      font-size 20px
      font-family MicrosoftYaHeiUI-Bold
      font-weight bold
      color rgba(42, 46, 54, 0.75)
      line-height 48px
      text-align center
      display inline-block
    .tasks
      .task
        margin-top 30px
        .taskinfo
          font-size 20px
          font-family MicrosoftYaHeiUI-Bold
          font-weight bold
          color rgba(42, 46, 54, 0.8)
          line-height 25px
          margin 20px 0
          word-wrap break-word
        .taskcontents
          .taskcontent
            .xcontent
              font-size 16px
              font-family MicrosoftYaHeiUI
              color rgba(42, 46, 54, 1)
              line-height 20px
    .showPlanBtn
      margin-top 20px
      float right
    .titlezd
      width 100%
      height 35px
      // background red
      font-size 18px
      color #2B7BE5
      line-height @height
    .xcontent
      width 100%
      height auto
      font-size 14px
      // background red
      margin 10px auto
    .xstuanswer
      background rgba(243, 243, 243, 1)
      border-radius 4px
      border 1px solid rgba(210, 221, 236, 1)
      padding 5px
      margin 10px 0
      word-wrap break-word
    .xbox
      background rgba(242, 245, 250, 1)
      border-radius 4px
      margin-bottom 50px
      padding 20px
      .answertitle, .xalanis, .xsysscore, .xkeywords
        width 100%
        height auto
        font-size 14px
        color #2B7BE5
        padding-left 10px
        border-left 5px solid #2B7BE5
      .xs, .xanswercontent, .xalaniscontent, .xkeywordcontent, .xanswercontent1, .xsysscore1
        height auto
        font-size 14px
        margin 10px 0 10px 20px
        span
          margin-right 20px
  .rightbox
    width 25%
    height 604px
    background white
    border-radius 3px
    overflow hidden
    float left
    padding 20px
    border-radius 0px 8px 8px 0px
    .title
      padding-left 10px
      font-size 16px
      font-family MicrosoftYaHeiUI-Bold
      font-weight bold
      color rgba(42, 46, 54, 1)
      line-height 20px
      border-left 4px solid #5CA5FC
    .userInfo
      text-align center
      margin 32px 0
      .userImg
        img
          width 72px
          height 72px
          border-radius 50%
      .userName
        font-size 14px
        color #2A2E36
      .totalscore
        margin-top 10px
        display inline-block
        height 100%
        font-size 32px
        font-family Arial-BoldMT
        font-weight normal
        color rgba(245, 166, 35, 1)
        line-height 37px
        text-align center
      .sysscore
        margin-top 20px
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .sys
          display inline-block
          margin-top 10px
          width 50%
          .content
            font-size 14px
            font-family MicrosoftYaHeiUI
            color rgba(163, 174, 184, 1)
            line-height 18px
          .littlescore
            font-size 16px
            font-family Arial-BoldMT
            font-weight normal
            color rgba(42, 46, 54, 0.75)
            line-height 18px
            white-space nowrap
            text-overflow ellipsis
            overflow hidden
    .change
      width 100%
      height 36px
      background #E6F1FF
      border-radius 4px
      color rgba(74, 144, 226, 1)
      // margin-left 5px
      border-color transparent
    .gray
      background #d2ddec !important
      color #c5c8ce !important
    .gobackBtn
      margin-top 14px
    .commit
      width 100%
      height 36px
      background #2789F0
      border-radius 4px
      color rgba(74, 144, 226, 1)
      // margin-left 5px
      font-size 14px
      font-family MicrosoftYaHeiUI
      color rgba(255, 255, 255, 1)
      line-height 18px
      margin-top 10px
      margin-bottom 500px
  .rightbox2
    width 25%
    height 604px
    padding 20px
    background white
    border-radius 3px
    overflow hidden
    float left
    .userInfo2
      padding-left 10px
      font-size 16px
      font-family MicrosoftYaHeiUI-Bold
      font-weight bold
      color rgba(42, 46, 54, 1)
      line-height 20px
      border-left 4px solid #5CA5FC
    .userImg2
      margin-top 20px
      height 32px
      img
        float left
        width 32px
        height 32px
        border-radius 50%
      .userName2
        float left
        font-size 14px
        height 32px
        font-family MicrosoftYaHeiUI
        color rgba(42, 46, 54, 1)
        line-height 32px
        margin-left 20px
    .sysscore2
      margin-top 34px
      overflow-y: auto;
      height: 470px;
      .sys2
        display: flex;
        align-items: center;
        justify-content: center;
        height 80px
        border-top 1px solid #F4F6F8
        .content2
          font-size 14px
          font-family MicrosoftYaHeiUI
          color rgba(42, 46, 54, 0.75)
          line-height 18px
          margin-bottom 10px
        .score
          height 62px
          text-align center
          line-height 62px
        .littlescoresys
          float left
          width 33%
          color rgba(163, 174, 184, 1)
          white-space nowrap
          text-overflow ellipsis
          overflow hidden
        .little1scoreself
          float left
          width 33%
          margin-top 12px
          margin-left 10%
        .span
          float left
          margin-left 5px
          line-height 62px
          color #999999
      .btn
        border-top 1px solid #D2DDEC
        height 50px
        width 100%
        display:flex;
        justify-content: center;
        .sure
          width 30%
          margin-top 3%
          background rgba(39, 137, 240, 1)
          color #fff
          margin-left 2%
        .cancel
          width 30%
          font-size 14px
          margin-top 3%
.dunhao div:last-child span
  display none
.tabItem2
  display:flex
.xanswercontent .tabItem2:last-child div div span
  display none
</style>
